<template>
	<div>
		<v-layout row wrap>
			<v-flex md9>
				<h2 class="title mb-0 mt-2">{{ titleTransfer }}: {{ name }}</h2>
			</v-flex>
			<v-flex md3 text-xs-right mb-3>
				<v-btn
					v-bind:disabled="isDisabled"
					class="btn-assign-tasks"
					v-on:click="assignToMinibar">
					Asignar al {{ assignText }}
				</v-btn>
			</v-flex>
		</v-layout>
		<table-run
			v-bind:columns="columns"
			v-bind:rows="rows"
			v-bind:include-delete="false"
			v-bind:include-export-to-excel="false"
			v-bind:include-options="false"
			v-bind:include-switch="false"
			v-bind:include-settings="false"
			v-bind:include-delete-single="false"
			key-value="warehouseProductId"
			v-on:on-sortable-event="columnSortableEvent"
			v-on:on-search-event="searchByColumn"
			class="no-search-table">
			<template slot="rows" scope="props">
				<td>
					<router-link
						:to="{ name: 'kardex', params: { productId: props.row.id,
						productName: props.row.name, warehouseId: props.row.warehouseId } }"
						class="to-kardex">
						{{ props.row.name }}
					</router-link>
				</td>
				<td>{{ props.row.warehouseName }}</td>
				<td>{{ props.row.stock }}</td>
				<td class="pr-2">
					<v-text-field
						type="number"
						class="time-standard-input"
						min="1"
						step="1"
						v-model="props.row.quantity"
						:suffix="props.row.unitCode"
						@keyup="toInt(props.row.quantity)"
					></v-text-field>
				</td>
				<td class="pr-2">
					<v-text-field
						type="number"
						class="time-standard-input stock"
						min="1"
						step="1"
						v-model.number="props.row.minStock"
						@keyup="absolute(props.row.minStock)"
					></v-text-field>
				</td>
			</template>
		</table-run>
		<v-layout row wrap justify-end mt-3 v-show="totalPages">
			<v-pagination
				:length="totalPages"
				:total-visible="pagesVisible"
				v-model="page"
				v-on:input="changePage">
			</v-pagination>
		</v-layout>
	</div>
</template>

<script>
	import mixin from '@/shared/mixins';
	import TableRun from 'table-run';

	function created() {
		this.loadData();
	}

	function absolute(val) {
		this.rows = this.rows.map((row) => {
			const newRow = { ...row };
			if (row.minStock === val) {
				newRow.minStock = Math.abs(val);
			}
			return newRow;
		});
	}

	function assignText() {
		return this.$route.name === 'warehouses-products' ? 'almacén' : 'minibar';
	}

	async function assignToMinibar() {
		const { data: brand } = await this.$http.get(`${process.env.PRODUCTS_URL}/p/brands/default`);
		const model = {
			warehouseId: this.id,
			entryDate: new Date(),
			details: this.rows.filter(row => row.isSelected).map((newRow) => {
				const detail = {
					brandId: brand.id,
					productId: newRow.id,
					quantity: newRow.quantity,
					minStock: newRow.minStock,
				};
				return detail;
			}),
		};
		if (model.details.length > 0) {
			const token = window.localStorage.getItem('housekeeping::token');
			await this.$http.post(`${process.env.PRODUCTS_URL}/v2/transfer-movement`, model, {
				headers: {
					authorization: `Bearer ${token}`,
				},
			});
			this.showNotification('Los productos se asignaron correctamente al minibar.', 'success');
			this.$router.push({ name: 'transfer-list' });
		} else {
			this.showNotification('Debe seleccionar por lo menos un producto.');
		}
	}

	async function changePage(value) {
		this.page = value;
		this.loadData();
	}

	function columnSortableEvent({ id }) {
		const self = this;
		const newColumn = self.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		self.columns = self.columns.map((columnSingle) => {
			const newColumnSingle = Object.assign({}, columnSingle);
			if ((columnSingle.id !== newColumn[0].id) && columnSingle.isSortable) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
			return newColumnSingle;
		});
		this.sortField = newColumn[0].code;
		this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
		this.loadData();
	}

	async function loadData() {
		const params = {
			flagActive: this.flagActive,
			limit: this.limit,
			page: this.page,
		};
		if (this.search) {
			params.search = this.search;
		}
		if (this.sortField) {
			params.sortField = this.sortField;
		}
		if (this.sortDirection) {
			params.sortDirection = this.sortDirection;
		}
		const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/products/minibar`, { params });
		this.totalPages = Number(response.headers.get('x-last-page'));
		this.rows = response.data.map((data) => {
			const newData = Object.assign({}, data);
			newData.quantity = 1;
			newData.minStock = 0;
			return newData;
		});
	}

	function pagesVisible() {
		return this.totalPages < 5 ? this.totalPages : 5;
	}

	function searchByColumn(search) {
		this.search = search;
		this.page = 1;
		this.loadData();
	}

	function titleTransfer() {
		this.columns[1].name = this.$route.name === 'warehouses-products' ? 'Almacén' : 'Minibar';
		return this.$route.name === 'warehouses-products' ? 'Almacén' : 'Minibar';
	}

	function toInt(value) {
		const newValue = value.toString();
		if (!value) {
			this.showNotification('El valor para cantidad debe ser un número válido', 'error');
			this.isDisabled = true;
		} else if (value <= 0) {
			this.showNotification('El mínimo valor requerido es 1', 'error');
			this.isDisabled = true;
		} else if (newValue && newValue !== '' && newValue.indexOf('.') > -1) {
			this.showNotification('El valor para cantidad debe ser un número entero', 'error');
			this.isDisabled = true;
		} else {
			this.isDisabled = false;
		}
	}

	export default {
		components: {
			TableRun,
		},
		computed: {
			assignText,
			pagesVisible,
			titleTransfer,
		},
		created,
		data() {
			return {
				columns: [
					{ id: 1, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } },
					{ id: 2, name: '', code: 'w.name', isSortable: { down: true, up: false } },
					{ id: 3, name: 'Stock', code: 'stock', isSortable: { down: true, up: false } },
					{ id: 4, name: 'Cantidad', code: 'quantity' },
					{ id: 5, name: 'Stock Mínimo', code: 'minStock' },
				],
				flagActive: 1,
				href: { name: 'transfer-list' },
				isDisabled: false,
				limit: 10,
				page: 1,
				rows: [],
				totalPages: 5,
				search: null,
				sortDirection: null,
				sortField: null,
			};
		},
		methods: {
			absolute,
			assignToMinibar,
			changePage,
			columnSortableEvent,
			loadData,
			searchByColumn,
			toInt,
		},
		mixins: mixin,
		name: 'minibar-products',
		props: ['id', 'name'],
	};
</script>

<style lang="scss" scoped>
	.title {
		color: map-get($colors, default-dark);
		font-size: map-get($sizes, breadcrumb) !important;
		text-align: left;
	}

	.to-kardex {
		color: inherit;
		font-family: inherit;
	}
</style>



// WEBPACK FOOTER //
// Products.vue?fa725412